import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_LOCATIONS } from "../../../utils/constants";
import { LocationInterface } from "../../../models/TicketModule/Location";
import locationService from "../../../services/ticketService/locationService";

interface AddLocationsContext {
  previousLocations: LocationInterface[];
}

const useAddLocation = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    LocationInterface,
    Error,
    LocationInterface,
    AddLocationsContext
  >({
    mutationFn: locationService.Save,

    onMutate: () => {
      const previousLocations =
        queryClient.getQueryData<LocationInterface[]>([
          CACHE_KEY_LOCATIONS,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ]) || [];

      return { previousLocations };
    },

    onSuccess: (savedLocation) => {
      queryClient.setQueryData<LocationInterface[]>(
        [
          CACHE_KEY_LOCATIONS,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        (locations) =>
          locations ? [savedLocation, ...locations] : [savedLocation]
      );
    },

    onError: (error, newLocation, context) => {
      if (!context) return;

      queryClient.setQueryData<LocationInterface[]>(
        [
          CACHE_KEY_LOCATIONS,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        context.previousLocations
      );
    },
  });
};

export default useAddLocation;
